import { Component } from "react";
class Speed extends Component {
  handleSubmit = (e) => {
    // console.log(SCDCID, SID, firstName, lastName, phonetic);

    // e.preventDefault();
    // dispatch(reset());
    // dispatch(hideError01());
    // if (SCDCID == "" && SID == "" && firstName == "" && lastName == "") {
    //   dispatch(reset());
    //   dispatch(showError01());
    //   return;
    // }
    // if (phonetic == false) {
    //   setPhonetic("");

    // fetch(
    //   "http://localhost:8080/d/inmatePicture.do?youth=+&id=" + SCDCID
    // )
    //   .then(async (response) => {
    //     const reader = await response.body.getReader();
    //     return new ReadableStream({
    //       start(controller) {
    //         return pump();
    //         function pump() {
    //           return reader.read().then(({ done, value }) => {
    //             // When no more data needs to be consumed, close the stream
    //             if (done) {
    //               controller.close();
    //               return;
    //             }
    //             // Enqueue the next data chunk into our target stream
    //             controller.enqueue(value);
    //             return pump();
    //           });
    //         }
    //       },
    //     });
    //   })
    //   .then((stream) => new Response(stream))
    //   .then((response) => response.blob())
    //   .then((blob) => URL.createObjectURL(blob))
    //   .then(async (url) => {
    //     await setPhoto(url);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // console.log(photo);

    fetch(
      "inmateSearch.do?lastName=k&firstName= &scdcId=&sid=&phoneticMatch=",
      {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        //body: JSON.stringify({ a: 7, str: "Some string: &=&" }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        // setInmates(res);
        // if (res.length == 500) {
        //   dispatch(showWarning01());
        // } else {
        //   dispatch(hideWarning01());
        // }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  render() {
    return (
      <div>
        <button onClick={this.handleSubmit} className="bg-blue-200 p-5 m-5">
          Test
        </button>
      </div>
    );
  }
}

export default Speed;
